import _ from 'lodash';
import IApplicationEmailAttachment from './IApplicationEmailAttachment';
import IApplicationEmailRecipient from './IApplicationEmailRecipient';
import IApplicationEmail from './IApplicationEmail';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function parseApplicationEmail(raw: any): IApplicationEmail {
    return {
        applicationUuid: raw.applicationUuid,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        attachments: _.map(raw.attachments, (attachment: any): IApplicationEmailAttachment => ({
            bytes: attachment.bytes,
            contentId: attachment.contentId,
            contentType: attachment.contentType,
            filename: attachment.filename,
            uuid: attachment.uuid,
        })),
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        recipients: _.map(raw.recipients, (recipient: any): IApplicationEmailRecipient => ({
            email: recipient.email,
            name: recipient.name,
            type: recipient.type,
        })),
        senderEmail: raw.senderEmail,
        senderName: raw.senderName,
        sentTime: raw.sentTime,
        subject: raw.subject,
        summary: raw.summary,
        uuid: raw.uuid,
    };
}
